export default __webpack_public_path__ + "static/media/logo.b53a3e73.png";